import groups from "@/api/groups";
import companies from "@/api/companies";
import users from "@/api/users";
import contacts from "@/api/contacts";
import agents from "@/api/agents";
import mailboxes from "@/api/mailboxes";
import auth from "@/api/auth";
import messages from "@/api/messages";
import emailThreads from "@/api/emailThreads";
import fields from "@/api/fields";
import settings from "@/api/settings";
import persons from "@/api/persons";
import servers from "@/api/servers";
import notifications from "@/api/notifications";
import meilisearch from "@/api/meilisearch";
export default {
  groups,
  companies,
  users,
  contacts,
  agents,
  mailboxes,
  auth,
  messages,
  emailThreads,
  fields,
  settings,
  persons,
  servers,
  notifications,
  meilisearch,
};
